import React from 'react';
import PropTypes from 'prop-types';

import Notification from '../notification';
import styles from './styles.css';

function RoleAccess({ fetching, children, roles, userRole, callback }) {
  const [canAccessPage, setCanAccessPage] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(fetching);

  React.useEffect(() => {
    if (roles.length && userRole) {
      setIsLoading(false);
      if (roles.includes(userRole)) {
        setCanAccessPage(true);
        callback(true);
      } else {
        Notification.error('Sorry, you do not have access to this page');
        setIsLoading(false);
      }
    }
  }, [roles, userRole]);

  return (
    !isLoading && !canAccessPage ? (<div className={styles.loader}>Sorry, you do not have access to this page</div>) : children
  );
}

RoleAccess.propTypes = {
  fetching: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  userRole: PropTypes.string.isRequired,
  callback: PropTypes.func,
};

RoleAccess.defaultProps = {
  callback: () => { },
};

export default RoleAccess;
